/**
 * Simulation constants.
 *
 * The simulation advances in fixed, integer-millisecond ticks and stores all
 * continuous quantities as integers. This is what makes a run reproducible from
 * `{ seed, commands }` alone — see `replay.ts`. Do not introduce floating-point
 * accumulation into stepped state.
 */

/** Length of one simulation tick, in milliseconds. 50 Hz. */
export const TICK_MS = 20;

/** Sub-floor resolution. Elevator position is stored in these units. */
export const MILLI_PER_FLOOR = 1000;

/**
 * Before a full floor may turn anyone away (ADR-0050): a person's time to see
 * the shift and tap, on top of the car's own time to come. The owner's first
 * taps in the hotel came at 1.3–4.5 s (PLAYTEST_LOG, 2026-10-28).
 */
export const LANDING_GRACE_REACTION_MS = 3000;

/**
 * Stops a car holds in the player's order (`addStop`): the floor it is going
 * to and the ones after it. A few, so a plan stays something a person makes.
 */
export const MAX_STOPS = 3;

/**
 * The cable (ADR-0033). The first floor of a run is the car getting under way;
 * past it, a better rope takes `longRunSavingPermille` of the motor's time off
 * every floor, up to `LONG_RUN_MAX_SAVING_PERMILLE`.
 */
export const LONG_RUN_AFTER_FLOORS = 1;
export const LONG_RUN_MAX_SAVING_PERMILLE = 750;
